import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import { TextValidator } from "react-material-ui-form-validator";
import Lang from "../../Utils/lang";
import style from "../Form.module.scss";
import PropTypes from "prop-types";

const lang = Lang.getInstance();
const PERSON = {
  naturalPerson: "Persoana fizica",
  legalPerson: "Persoana juridica",
};
function Address({
  personalData,
  onChange,
  streets,
  handleChangeStreet,
  person,
}) {
  return (
    <>
      <Typography className={style.addressTitle}>
        {person === PERSON.naturalPerson ? (
          <>{lang.get("address")}</>
        ) : (
          <>{lang.get("legalAddress")}</>
        )}
      </Typography>
      <Grid container spacing={2}>
        <Grid item sx={12} md={3} lg={3}>
          <TextValidator
            label="Județ"
            type="text"
            name="county"
            variant="standard"
            fullWidth
            value={personalData.county}
            onChange={(e) => onChange(e)}
            validators={["required"]}
            errorMessages={[lang.get("textFieldRequired")]}
          />
        </Grid>
        <Grid item sx={12} md={3} lg={3}>
          <TextValidator
            label="Localitate"
            type="text"
            name="city"
            variant="standard"
            fullWidth
            value={personalData.city}
            onChange={(e) => onChange(e)}
            validators={["required"]}
            errorMessages={[lang.get("textFieldRequired")]}
          />
        </Grid>
        <Grid item sx={12} md={6} lg={6}>
          <Autocomplete
            name="street"
            options={streets}
            value={personalData.address.street}
            freeSolo
            selectOnFocus
            handleHomeEndKeys
            renderInput={(params) => (
              <TextField
                {...params}
                label="Strada"
                variant="standard"
                fullWidth
                onChange={(event, newValue) =>
                  handleChangeStreet(event, newValue)
                }
              />
            )}
            onChange={(event, newValue) => handleChangeStreet(event, newValue)}
          />
        </Grid>
        <Grid item sx={12} md={3} lg={3}>
          <TextValidator
            label="Număr"
            type="text"
            name="address_nr"
            variant="standard"
            fullWidth
            value={personalData.address.nr}
            onChange={(e) => onChange(e)}
          />
        </Grid>
        <Grid item sx={12} md={3} lg={3}>
          <TextValidator
            label="Bloc"
            type="text"
            name="address_bl"
            variant="standard"
            fullWidth
            value={personalData.address.bl}
            onChange={(e) => onChange(e)}
          />
        </Grid>
        <Grid item sx={12} md={3} lg={3}>
          <TextValidator
            label="Scară"
            type="text"
            name="address_sc"
            variant="standard"
            fullWidth
            value={personalData.address.sc}
            onChange={(e) => onChange(e)}
          />
        </Grid>
        <Grid item sx={12} md={3} lg={3}>
          <TextValidator
            label="Apartament"
            type="number"
            name="address_ap"
            variant="standard"
            fullWidth
            value={personalData.address.ap}
            onChange={(e) => onChange(e)}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Address;

Address.propTypes = {
  personalData: PropTypes.object,
  onChange: PropTypes.func,
  streets: PropTypes.object,
  handleChangeStreet: PropTypes.func,
  person: PropTypes.string,
};
